module.exports = __webpack_public_path__ + "img/Bahrain.de907e92.png";